// extracted by mini-css-extract-plugin
module.exports = {"pessimization":"_93444fe79c--pessimization--aR_Id","strong":"_93444fe79c--strong--jcLb6"};